import styled from 'styled-components';

import { AnchorButton } from 'components/Button/AnchorButton';

export const CircleButton = styled(AnchorButton)`
  border-radius: 50%;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25);
  height: 40px;
  width: 40px;

  &.medium {
    padding: 0;
  }
`;
